import React from 'react';
import Dropdown from '../../Dropdown/MainDropdown';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { PlusIcon } from '../../accounting/styles';

interface Props {
  renderDropdownItems?: JSX.Element;
  onFileUpload?: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
}

const CreateFilesDropdown: React.FC<Props> = ({ renderDropdownItems, onFileUpload }) => {
  return (
    <>
      <Dropdown
        isMinWidth={196}
        isRemoveMaxHeight={true}
        content={
          <PlusIcon>
            <SVGIcon name='plus-icon' width='20' height='20' viewBox='0 0 18 18' fill='var(--text-white)' />
          </PlusIcon>
        }
        trigger='click'>
        {renderDropdownItems}
      </Dropdown>
      <input type='file' id='upload' hidden multiple onChange={onFileUpload} />
    </>
  );
};

export default CreateFilesDropdown;
